module.exports = __webpack_public_path__ + "static/carousel-slide-04-8d26ace4d7fabdfee6b9ef506f728364.png";